import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=22e9ad94&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e9ad94')) {
      api.createRecord('22e9ad94', component.options)
    } else {
      api.reload('22e9ad94', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=22e9ad94&", function () {
      api.rerender('22e9ad94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M3lAfT4xBSux/JS/offershelp.vue"
export default component.exports